<template>
  <div class="py-3">
    <h4 class="text-center mb-2">{{ $t('reports.unitInspections') }}</h4>
    <v-data-table
      :loading="loadingTable"
      :loading-text="$t('general.loading')"
      :headers="headers"
      :items="inspections"
      :server-items-length="totalItems"
      :options="optionsDataTable"
      :footer-props="{ 'items-per-page-options': [10, 15, 50] }"
      @update:options="onOptionsChange"
      item-key="id"
      dense
    >
      <template v-slot:item.consecutive_number="{ item }">
        {{ item.consecutive_number || 'N/A' }}
      </template>
      <template v-slot:item.created_at="{ item }">
        {{ formatDateTime(item.created_at) }}
      </template>
      <template v-slot:item.name="{ item }">
        {{ item.checklist_name || 'N/A' }}
      </template>
      <template v-slot:item.duration="{ item }">
        {{ item.duration || 'N/A' }}
      </template>
      <template v-slot:item.inspector="{ item }">
        {{ formatFullName(item.inspector) }}
      </template>
      <template v-slot:item.operator="{ item }">
        {{ formatFullName(item.operator) }}
      </template>
      <template v-slot:item.site="{ item }">
        {{ item.site ? item.site.name : 'N/A' }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon small color="primary" @click="viewInspection(item.id)" v-bind="attrs" v-on="on">
              <v-icon small>far fa-eye</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('general.view') }}</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
const DEFAULT_SORT_KEY = 'created_at'

export default {
  name: 'inspectionCountByUnitDetails',
  props: {
    inspectionIds: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      loadingTable: false,
      totalItems: 0,
      optionsDataTable: {
        itemsPerPage: 10,
        page: 1,
        sortBy: [DEFAULT_SORT_KEY],
        sortDesc: [true]
      },
      inspections: []
    }
  },
  watch: {
    // La tabla padre puede reutilizar este componente con otros ids al volver a filtrar
    inspectionIds () {
      if (this.optionsDataTable.page === 1) return this.get()
      this.optionsDataTable = { ...this.optionsDataTable, page: 1 }
    }
  },
  computed: {
    headers () {
      return [
        { text: this.$t('general.noInspection'), align: 'center', value: 'consecutive_number' },
        { text: this.$t('general.inspectionDate'), align: 'center', value: 'created_at' },
        { text: this.$t('general.checklistName'), align: 'center', value: 'name' },
        { text: this.$t('general.duration'), align: 'center', value: 'duration' },
        { text: this.$t('general.inspector'), align: 'center', value: 'inspector' },
        { text: this.$t('general.operator'), align: 'center', value: 'operator' },
        { text: this.$t('general.inspectionYard'), align: 'center', value: 'site' },
        { text: this.$t('general.actions'), align: 'center', value: 'actions', sortable: false }
      ]
    }
  },
  methods: {
    onOptionsChange (options) {
      // v-data-table emite update:options al montarse, eso dispara la primera carga
      this.optionsDataTable = options
      this.get()
    },
    get () {
      if (this.inspectionIds.length === 0) {
        this.inspections = []
        this.totalItems = 0
        return
      }

      const { page, itemsPerPage, sortBy, sortDesc } = this.optionsDataTable
      const hasSort = sortBy && sortBy.length > 0

      this.loadingTable = true
      this.$store.dispatch('reports/getInspectionCountByUnitDetails', {
        event: {
          context: this,
          params: {
            inspection_ids: this.inspectionIds,
            sort_by: hasSort ? sortBy[0] : DEFAULT_SORT_KEY,
            sort_direction: !hasSort || (sortDesc && sortDesc[0]) ? 'desc' : 'asc',
            perPage: itemsPerPage,
            page
          }
        }
      })
    },
    viewInspection (id) {
      this.$router.push(`/reports/inspectionCountByUnit/view/${id}`)
    },
    formatFullName (person) {
      if (!person) return 'N/A'
      return [person.name, person.last_name].filter(Boolean).join(' ') || 'N/A'
    },
    formatDateTime (value) {
      if (!value) return 'N/A'

      const date = new Date(value)
      if (isNaN(date.getTime())) return value

      const pad = number => String(number).padStart(2, '0')
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ` +
        `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
    }
  }
}
</script>
